import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { callRestAPI, uploadVideo } from 'main/utils/rest-apis';

import { selectUserToken } from 'main/store/common/selectors';
import { selectSharedVideoData } from 'main/store/videos/selectors';

export const UploadButton = () => {
    const dispatch = useDispatch();
    const token = useSelector(selectUserToken)!;
    const sharedVideoData = useSelector(selectSharedVideoData);


    const handleClick = useCallback(() => {

        callRestAPI(dispatch, async () => {
            await uploadVideo(sharedVideoData, token);
        });

    }, [sharedVideoData, token, dispatch]);

    return (
        <Button variant="contained" onClick={handleClick}>
            アップロード
        </Button>
    )
}
